import { FundsOriginChannelEnum } from '../common/enums/fundsOriginEnum'
import { IFundsOriginListResponse } from '../common/interfaces'
import { apiUrl } from '../config/api'

export const FundsOriginService = () => {
  const list = (channel?: FundsOriginChannelEnum) =>
    apiUrl
      .get('funds-origin/list', { params: channel ? { channel } : undefined })
      .then((res) => res.data as IFundsOriginListResponse)

  return {
    list,
  }
}
